import { Button, ButtonProps } from '@amzn/ring-ui-react-components';
import { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'src/shared/components/Icon';

export interface UploadYourVideoButtonProps extends ButtonProps {
  onClick: () => void;
  innerRef?: RefObject<HTMLDivElement>;
}

export const UploadYourVideoButton = ({
  onClick,
  innerRef,
  ...props
}: UploadYourVideoButtonProps) => {
  const { t } = useTranslation('features.bestOfRing');
  return (
    <Button
      pr={13}
      borderRadius="full"
      size="xs"
      height="36px"
      textStyle="body-large-bold"
      onClick={onClick}
      {...props}
    >
      <Icon name="submit_video" color="white" size={24} mr={1} />
      <span ref={innerRef}>{t('submit-your-video')}</span>
    </Button>
  );
};
